

import VimeoPlayer from '@vimeo/player';


// VIDEO PLAYER ABSTRACTION
//    - support vimeo, youtube, struct that points to the actual players
//    - Usage: var player = new VideoPlayer(element)
//    - Creation: differs by player type
//        - <Youtube> react creates player struct, it on first state change we bind it to class
//        - <vimeo> create player struct on init, and bind to object
//    - ops: use same interface after bind to class
//

// event: https://alephnode.io/07-event-handler-binding/
// vimeo api: https://developer.vimeo.com/player/sdk/reference
// youtube api: https://developers.google.com/youtube/iframe_api_reference
export class VideoPlayerClass {
    _element = null;
    _player = null;
    _type = null;
    _vimeo_state = null;
    _speed = null;
    _from = null;
    _url = null;
    _paused = null;
    _stop_secs = null;
    _last_secs = null;      // kludge for native stepping issue
    _handler = null;    // if caller wants to be informed


    
    constructor(element, from) {
        if(element !== null){
            var copy = {...element};        // see a invariant snapshot
            console.log("vidclass.127:       CREATE NEW ABSTRACT VIDEO PLAYER  from=",from, " ",copy);
            this._element = element;
            this._from = from;
        }
    }


    // faster version
    get paused() {
        return this._paused;
    }

    get player() {
        return this._player;        // to trap events
    }

    get type() {
        return this._type;
    }

    _vimeo_setup = (player) => {
        player.on('loadeddata', this._handleVimeoOnLoadeddata);       // trap vimeo events
        player.on('ended', this._handleVimeoOnEnded);       // trap vimeo events
        player.on('error', this._handleVimeoOnError);       // trap vimeo events
        player.on('play', this._handleVimeoOnPlay);       // trap vimeo events
        player.on('playing', this._handleVimeoOnPlaying);       // trap vimeo events
        player.on('pause', this._handleVimeoOnPause);       // trap vimeo events
        player.on('ready', this._handleVimeoOnReady);       // trap vimeo events
        player.on('seeked', this._handleVimeoOnSeeked);       // trap vimeo events
        player.on('waiting', this._handleVimeoOnWaiting);       // trap vimeo events
        player.on('progress', this._handleVimeoOnProgress);       // trap vimeo events
        //console.log("vidclass.52:     .  .  .  .  .  VIMEO EVENTS SETUP  _player=",player);
    }



    // late binding of youtube player to wrapper
    //
    bind = (player) => {
        switch(this._type) {
            case "vimeo":
                console.log("vidclass.42:       REDUNDANT VIMEO BIDING"); //, player);
                break;
            case "youtube":
                this._player = player;      // this is created by <react-youtube>, we just remember it
                console.log("vidclass.45:       BIND YOUTUBE PLAYER  url=", player.playerInfo.videoUrl);  //, player);
                break;
            case "native":
                this._player = player;      // this is created by <react-youtube>, we just remember it
                console.log("vidclass.83:       BIND NATIVE PLAYER ");
                break;
        }
    }


    start = () => {
        console.log("vidclass.56:           -  -  -  -   STARTING PLAYER      speed=", this._speed, " state=", this.getPlayerState());
        this._paused = false;
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    this._player.play();      // vimeo
                    break;
                case "youtube":
                    this._player.playVideo();
                    break;
                case "native":
                    this._player.play();      // vimeo
                    this._last_secs = null;
                    break;
            }
        }

    }

    stop = () => {
        console.log("vidclass.89:          -  -  -  -  STOPPING PLAYER       state=", this.getPlayerState());
        this._paused = true;
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    this._player.pause();
                    break;
                case "youtube":
                    this._player.stopVideo();
                    break;
                case "native":
                    this._player.pause();      // vimeo
                    break;
            }
        }
    }


    pause = async () => {
        var state = this.getPlayerState();
        console.log("vidclass.104:          -  -  -  -   PAUSING PLAYER       state=", state, "  time=",this.getTime());
        if (this._player !== null) {
            switch(this._type) {
                case "native":
                    var curr = await this.getTime()
                    this._player.pause();
                    this._last_secs = curr;     // MEGA KLUDEG: subtract weird offset
                    console.log("vidclass.141:    NATIVE PAUSED SECS=",(curr));
                    break;
                case "vimeo":
                    if (this._paused === false) {
                        this._player.pause();
                    }
                    break;
                case "youtube":
                    if(state == "playing") {
                        this._player.pauseVideo();      // will show "related video"
                    }

                    // attemp to hide the "related video"
                    // class="ytp-pause-overlay ytp-scroll-min"
                    //var related = document.querySelector("div.ytp-pause-overlay.ytp-scroll-min");
                    //var related = document.querySelector("div.drill_output");
                    //related.display = "none";
                    //var ifr = document.querySelector("iframe").contentWindow.document.querySelector("div")
                    //console.log("vidclass.98:    YT RELATED ELEMENT =",ifr);

                    break;
            }
        }
        this._paused = true;
    }


    // move single frames
    //
    singleStep = async (steps) =>  {
        var curr = await this.getTime()
        //console.log("vidclass.166:        . . . . . . SINGLE STEP GET TIME=",curr.toFixed(3));

        if(this.type === "native") {
            // MEGA KLUDGE: work around bad native current time, if last one was single step, this one use lsat time
            if(this._last_secs) curr = this._last_secs;
            this._last_secs = null;
        }

        var target = parseFloat(curr) + (0.05 * steps);
        //console.log("vidclass.113:   . . .  VIDEO STEP  steps=",steps, " curr=",curr.toFixed(3), " target=",target.toFixed(3));
        this.setTime(target);
    }


    mute = () => {
        if (this._player !== null) {
            console.log("vidclass.120:   MUTE      state=",this.getPlayerState());
            switch(this._type) {
                case "vimeo":
                    this._player.setVolume(0);      // vimeo
                    break;
                case "youtube":
                    this._player.mute();
                    break;
            }
        }
    }

    getDuration = () => {
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    return this._player.getDuration();      // vimeo

                case "youtube":
                    return this._player.getDuration();

                case "native":
                    return 999;
            }
        }
    }

    getPlayerURL = () => {
        var url = null;
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    url = this._player.element.attributes.url.value;
                    console.log("vidclass.176:   VIMEO PLAYER URL =",this._player);
                    break;
                case "youtube":
                    url = this._player.playerInfo.videoUrl;
                    break;
                case "native":
                    url = this._url;
                    break;
            }
        }
        return url;
    }


    getPlayerState = () => {
        var code = null, state = null;
        const YTSTATUS = ["unstarted", "ended", "playing", "pause", "waiting", "unknown", "ready"]; // ready = cued, 
        const NTSTATUS = ["got_nothing", "have_metadata", "have_currrent_data", "have_future_data", "have_enough_data"]; 
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    state = this._vimeo_state;      // return last captured event state
                    break;
                case "youtube":
                    code = this._player.getPlayerState();
                    state =  YTSTATUS[code + 1];
                    break;
                case "native":
                    code = this._player.readyState;
                    state =  NTSTATUS[code];
                    break;
            }
        }
        //console.log("vidclass.178:    .  .  .  .  .  Return Player STATE=",state, " code=",code);
        return state;
    }

    getPaused = () => {
        var status = false;
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    status = this._player.getPaused()      // vimeo
                            .then(result=> {
                                //console.log("vidclass.119:    GET PAUSED  =",result);
                                return result;
                            })
                    break;
                case "youtube":
                    // -1 – unstarted 
                    //  0 – ended
                    //  1 – playing
                    //  2 – paused
                    //  3 – buffering
                    //  5 – video cued
                    //console.log("vidclass.177:    YT getPaused player=",this._player);
                    var state = this._player.getPlayerState();
                    if (state != "1") {
                        status = true;
                    }
                    //console.log("vidclass.174:    GET PAUSED YT_STATE =",state, " paused=",status);
                    break;

                case "native":
                    status = this._player.paused;
                    break;
            }
        }
        return status;
    }


    // return true if player has a URL already
    //
    getURL = () => {
        var status = false;
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    //console.log("vidclass.195:    VIMEO STATE  =",this._element);
                    if (this._element.src !== undefined) {
                        status = true;
                    }
                    break;
                case "youtube":
                    console.log("vidclass.195:    YOUTBUE STATE  =",this._element);
                    break;
                case "native":
                    status = this._url;
                    break;
            }
        }
        return status;
    }

    setURL = (url) => {
        this._url = url;
    }

    // NATIVE PLAYER ONLY (AUTO STOP)
    //    - stop once reached a time
    //    - upstream watch for pause
    //
    setStop = (seconds0) => {
        if ((this._type === "native") && (this._player)) {
            console.log("vidclass.303:      SET STOP TIME @",seconds0);
            
            const timeupdate = () => {      // NOTE: MUST BE DEFINED BEFORE IT IS CALLED!
                var seconds = parseFloat(this._stop_secs);
                var player = this._player;
                //console.log("vidclass.305:         . . . . .  timeupdate=",player.currentTime, "  end=",seconds);
                if(player.currentTime >= (seconds)) {
                    player.pause();
                    player.removeEventListener("timeupdate", timeupdate, false);
                    console.log("vidclass.315:         . . . . .  PLAYER STOPPED  timeupdate=",player.currentTime, "  end=",seconds);
                }
            };

            this._stop_secs = parseInt(seconds0);
            this._player.addEventListener("timeupdate", timeupdate, false);
        }
    }



    setTime = (seconds0) => {
        var seconds = parseFloat(seconds0);
        var current = this.getTime();
        //console.log("vidclass.166:        . . . . . . SET TIME GET TIME=",current.toFixed(3));
        if ((typeof(seconds) !== "number") || (seconds < 0)) {
            console.log("vidclass.268:    !!!!!!!!! INVALID SETTIME  seconds=",seconds);
            seconds = 0;
            //return null;     // invalide
        }

        if (this._player !== null) {
            seconds = (!seconds) ? 0 : parseFloat(seconds);
            switch(this._type) {
                case "vimeo":
                    this._player.setCurrentTime(seconds);
                    break;
                case "youtube":
                    this._player.seekTo(seconds, true);
                    break;
                case "native":
                    this._player.currentTime = seconds.toString();     // set it when it can play
                    //console.log("vidclass.223:        . . . . . . ADVANCE FOOTAGE TO =",seconds.toFixed(3), " get_time=", current.toFixed(3), " ncurrent=",this.getTime().toFixed(3));
                    this._last_secs = seconds;
                    break;
            }
        }
    }


    getTime = () => {
        var time = null;
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    time = this._player.getCurrentTime()
                    break;
                case "youtube":
                    time = this._player.getCurrentTime()
                    break;
                case "native":
                    time = this._player.currentTime;
                    break;
            }
        }
        return time;
    }


    setEventHandler = (handler) => {
        console.log("vidclass.312:        .  .  .  .  PLAYER EVENT HANDLER REGISTERED ");   //,handler);
        this._handler = handler;
    }

    setSpeed = (speed) => {
        if ((this._player !== null) && speed) {
            console.log("vidclass.261:        .  .  .  .  SET PLAYER SPEED=",speed);
            this._speed = speed;
            switch(this._type) {
                case "vimeo":
                    this._player.setPlaybackRate(speed);
                    break;
                case "youtube":
                    // Possible Speeds: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
                    this._player.setPlaybackRate(speed);
                    break;
                case "native":
                    this._player.playbackRate = speed;
                    break;
            }
        }
    }

    setType = (ptype) => {
        switch(ptype) {
            case "vimeo":
                if ((this._player === null) && (this._element.src !== undefined)) {
                    // create vimeo player and bind to object
                    var player = new VimeoPlayer(this._element);   // bind vimeo player
                    this._player = player;      // bind to actual vimeo player
                    this._vimeo_setup(player);        // setup event listeners
                }
                console.log("vidclass.290:       BIND0 NEW VIMEO PLAYER  player=",this._player);        // element=", this._element);
                break;
            case "youtube":
                this._player = null;        // late binding from <react-youtube>
                break;
            case "native":
                this._player = this._element;        // native <video>
                break;
            default:
                console.log("vidclass.112:  ***** UNKNOWN TYPE ",ptype);
                return null;
        }
        this._type = ptype;
    }

    destroy = () => {
        if (this._player !== null) {
            switch(this._type) {
                case "vimeo":
                    this._player.destroy();      // vimeo
                    break;
                case "youtube":
                    this._player.destroy();
                    break;
            }
        }
    }

    // src: https://developer.vimeo.com/player/sdk/reference
    // API ref: https://www.npmjs.com/package/@vimeo/player?activeTab=readme
    //     [ abort, canplay, ended, error, loadeddata, pause, play, playing, progress, seeked, waiting, stalled]
    //    - catch all events: https://stackoverflow.com/questions/5107232/is-it-possible-to-programmatically-catch-all-events-on-the-page-in-the-browser
    //
    _handleVimeoOnLoadeddata = (event0) => {
        //console.log("vidclass.428:        ~~~~~~~~~~~~  VIMEO EVENT:  ON LOADED DATA",event);
        var event = "loaded_data";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnReady = (event0) => {
        //console.log("vidclass.444:        ~~~~~~~~~~~~  VIMEO EVENT:  ON READY? ",event);
        var event = "ready";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnPlay = (event0) => {
        //console.log("vidclass.436:        ~~~~~~~~~~~~  VIMEO EVENT:  ON PLAY",event);
        var event = "play";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnPlaying = (event0) => {
        //console.log("vidclass.432:        ~~~~~~~~~~~~  VIMEO EVENT:  ON PLAYING",event);
        var event = "playing";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnSeeked = (event0) => {
        //console.log("vidclass.449:        ~~~~~~~~~~~~  VIMEO EVENT:  ON SEEKED ",event);
        var event = "seeked";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnProgress = (event0) => {
        //console.log("vidclass.422:        ~~~~~~~~~~~~  VIMEO EVENT:  ON PROGRESS ",event);
        var event = "progress";
        this._vimeo_state = event; 
        this._handler(event);
    }


    _handleVimeoOnEnded = (event0) => {
        //console.log("vidclass.431:        ~~~~~~~~~~~~  VIMEO EVENT:  ON ENDED",event);
        var event = "ended";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnPause = (event0) => {
        //console.log("vidclass.440:        ~~~~~~~~~~~~  VIMEO EVENT:  ON PAUSE",event);
        var event = "pause";
        this._vimeo_state = event; 
        this._handler(event);
    }

    _handleVimeoOnWaiting = (event0) => {
        //console.log("vidclass.449:        ~~~~~~~~~~~~  VIMEO EVENT:  ON WAITING ",event);
        var event  = "waiting";
        this._vimeo_state= event; 
        this._handler(event);
    }

    _handleVimeoOnError = (event0) => {
        console.log("vidclass.431:        ~~~~~~~~~~~~  VIMEO EVENT:  ON ERROR",event);
        var event = "error";
        this._vimeo_state = event; 
        this._handler(event);
    }


}